import React from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { navigate } from './constants';
import * as dateMath from "date-arithmetic";
import Popover from 'antd/lib/popover';
// import 'antd/lib/popover/style/index.css';
import Calendar from 'antd/lib/calendar';
// import 'antd/lib/calendar/style/index.css';
import moment from 'moment';
import { CALENDAR_VIEWS } from "../roster/constants";
import { viewConstants } from "../../_constants/view.constants";
import * as instructorActions from "../../_actions/roster.actions";

const NORMALWORKING_ACTION = 99

class Toolbar extends React.Component {
  state = {
    visible: false,
    displayLabel: '',
    current: moment(new Date()),
  };

  handleVisibleChange = visible => {
    this.setState({ visible });
  };

  onSelect = date => {
    this.setState({
      visible: false,
      current: date,
    });

    // const options = {
    //   range: viewConstants.WEEK,
    //   time: date.toDate() || new Date(),
    //   ActionType: {op:'EQ', value: NORMALWORKING_ACTION}
    // };

    // this.props.actions.rosterActions.updateWeeklyReportEvents(options);

    this.props.onNavigate(navigate.DATE, date);

    this.getDatelable(date);
  };

  getDatelable = date => {
    const start = this.getFirstWeekDay(date);

    const startLabel = `${start.format('DD/MM/YYYY')}`;
    const end = this.getLastWeekDay(date);
    const lastLabel = `${end.format('DD/MM/YYYY')}`;

    const dateLabel = startLabel + `-` + lastLabel;
    this.setState({ displayLabel: dateLabel });
  };

  getDatelableCurrent = () => {
    const now = moment(new Date());
    const start = this.getFirstWeekDay(now);

    const startLabel = `${start.format('DD/MM/YYYY')}`;
    const end = this.getLastWeekDay(now);
    const lastLabel = `${end.format('DD/MM/YYYY')}`;

    const dateLabel = startLabel + ` ~ ` + lastLabel;
    return dateLabel;
  };

  getFirstWeekDay = date => {
    const firstDay = date.startOf('isoWeek');
    return firstDay;
  };

  getLastWeekDay = date => {
    const lastDay = date.endOf('isoWeek');
    return lastDay;
  };

  render() {
    let {
      label
    } = this.props;

    let { displayLabel } = this.state;
    let popover = (
      <div className="popover-calendar">
        <Calendar fullscreen={false} onSelect={this.onSelect} />
      </div>
    );

    return (
      <div className="rbc-toolbar">
        <span className="rbc-btn-group">
          <button type="button" onClick={this.navigate.bind(null, navigate.PREVIOUS)}>
            <i className="fas fa-angle-double-left" />
          </button>
          <Popover
            content={popover}
            placement="bottom"
            trigger="click"
            open={this.state.visible}
            onOpenChange={this.handleVisibleChange}
          >
            <button type="button">
              {displayLabel === '' ? this.getDatelableCurrent() : displayLabel}
            </button>
          </Popover>
          <button type="button" onClick={this.navigate.bind(null, navigate.NEXT)}>
            <i className="fas fa-angle-double-right" />
          </button>
        </span>

        <span className="rbc-toolbar-label">{label}</span>
      </div>
    );
  }

  rangeChange = (date, action, view) => {
    switch (view) {

      case CALENDAR_VIEWS.WEEK:
        return this.navigateWeek(date, action);

      default:
        return date;
    }
  };

  navigateWeek = (date, action) => {
    switch (action) {
      case navigate.PREVIOUS:
        return dateMath.add(date, -1, "week");

      case navigate.NEXT:
        return dateMath.add(date, 1, "week");

      default:
        return date;
    }
  };

  navigate = action => {
    const newDate = this.rangeChange(this.state.current.toDate(), action, viewConstants.WEEK);

    if(navigate.PREVIOUS === action){
      const previousWeek = this.state.current.subtract(1, 'week');
      this.getDatelable(previousWeek);
    }else if(navigate.NEXT === action){
      const nextWeek = this.state.current.add(1, 'week');
    this.getDatelable(nextWeek);
    }
    
    this.setState({
      current: moment(newDate)
    });

    // const options = {
    //   range: viewConstants.WEEK,
    //   time: newDate || new Date(),
    //   ActionType: {op:'EQ', value: NORMALWORKING_ACTION}
    // };

    // this.props.actions.rosterActions.updateWeeklyReportEvents(options);

    this.props.onNavigate(action, this.state.current.toDate());
  };

  view = view => {
    this.props.onView(view);
  };

}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      rosterActions: bindActionCreators(instructorActions, dispatch)
    }
  };
}

export default connect(null, mapDispatchToProps)(Toolbar);
